import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=3109c498&scoped=true&"
import script from "./DragAndDrop.vue?vue&type=script&lang=js&"
export * from "./DragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDrop.vue?vue&type=style&index=0&id=3109c498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3109c498",
  null
  
)

export default component.exports